// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderTotal_wrapper__73LwZ","total":"OrderTotal_total__mcRTv"};